// An AWS account as a screen names it (#823): what the workspace calls it, with the
// 12-digit id on hover, or the id itself where nobody has named it.

export function AccountName({ id, name }: { id: string; name: string | null | undefined }) {
  if (name === null || name === undefined) return <code>{id}</code>;
  return (
    <span title={`AWS account ${id}`} data-account-id={id}>
      {name}
    </span>
  );
}
